import type { IssueMode } from '../types/issue';

/** Nomes do método no workspace estruturado. Não substitui status, histórico nem o rótulo canônico da etapa. */
const STRUCTURED_STAGE_LABELS: Record<string, string> = {
  ident: 'Identificação',
  analysis: 'Observação',
  root: 'Análise',
  plan: 'Plano de ação',
  exec: 'Execução',
  valid: 'Verificação',
  monitor: 'Padronização',
  close: 'Conclusão',
};

export function presentStageLabel(
  mode: IssueMode | null | undefined,
  key: string,
  fallback: string,
): string {
  if (mode === 'quick_correction') return fallback;
  return STRUCTURED_STAGE_LABELS[key] ?? fallback;
}
